import { render, staticRenderFns } from "./ModifyAccount.vue?vue&type=template&id=b15b3b1a&scoped=true&"
import script from "./ModifyAccount.vue?vue&type=script&lang=js&"
export * from "./ModifyAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15b3b1a",
  null
  
)

export default component.exports